import EmbedDefault, { type EmbedData } from '@/components/embeds/EmbedDefault/EmbedDefault'
import styles from './StorylineEmbed.module.scss'
import AppContext from '@/types/context'

export default function Embed({
  item,
  context,
}: {
  readonly item: {
    readonly model: {
      readonly fields: {
        readonly data: {
          readonly value: string
        }
      }
    }
  }
  readonly context: AppContext
}) {
  const model = item.model
  const validateEmbedData = (): EmbedData | undefined => {
    let json: undefined | EmbedData = undefined
    try {
      json = JSON.parse(model.fields.data.value)
    } catch {
      json = undefined
    }

    if (json && json.params) {
      if (typeof json.params === 'object') {
        const params = json.params
        for (const key in params) {
          if (typeof params[key] !== 'string') json = undefined
        }
      } else {
        json = undefined
      }
    }

    if (json && typeof json?.provider === 'string' && typeof json?.url === 'string') {
      if (json.url.startsWith('//')) json.url = 'https:' + json.url
      try {
        new URL(json.url)
      } catch {
        json = undefined
      }
    }

    return json
  }
  const data = validateEmbedData()

  if (data)
    return (
      <div className={styles.wrapper}>
        <EmbedDefault
          provider={data.provider}
          url={data.url}
          params={data.params}
          cookies={context.cookies}
        ></EmbedDefault>
      </div>
    )
  return <></>
}
